import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { ParagraphSecondary } from 'mage-deps/@klarna/bubble-ui'
import { actions as cmsActions, useCMSEnvironment } from 'mage-cms'
import { withResponsive } from './Grid'

const options = [
  {
    value: '',
    hidden: true
  },
  {
    value: 'master'
  },
  {
    value: 'dev'
  },
  {
    value: 'test'
  }
]

CMSEnvironmentSelector.propTypes = {
  isMobile: PropTypes.bool.isRequired
}

function CMSEnvironmentSelector ({ isMobile }) {
  const dispatch = useDispatch()
  const cmsEnvironment = useCMSEnvironment()

  if (!cmsEnvironment) return null

  const label = isMobile ? 'CMS' : 'CMS Environment'

  return (
    <>
      <ParagraphSecondary>{label}</ParagraphSecondary>
      <Select value={cmsEnvironment} options={options} onChange={onChange} />
    </>
  )

  function onChange (value) {
    dispatch(cmsActions.setCMSEnvironment(value))
  }
}

export default withResponsive(CMSEnvironmentSelector)

Select.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

function Select ({ options, value, onChange }) {
  return (
    <select
      id='cms-environment-selector'
      style={{ height: 30 }}
      value={value}
      onChange={event => onChange(event.target.value)}
    >
      {options.map(
        option => (
          <option
            key={option.value}
            value={option.value}
            hidden={option.hidden}
          >
            {option.value}
          </option>
        )
      )}
    </select>
  )
}
